<div class="relative h-full w-full flex flex-col overflow-hidden">

    <!-- Single thread options menu -->
    <app-menu #threadOptionsMenu [items]="getThreadMenuItems(currentThreadForMenu())"></app-menu>

    <!-- Edit thread title dialog (Rename) -->
    <app-edit-thread [(visible)]="editThreadDialogVisible" [(threadTitle)]="threadTitleForEdit"
        (onSave)="onSaveThreadTitle()">
    </app-edit-thread>

    <!-- History popover -->
    <app-popover #historyPanel [width]="'24rem'" [maxHeight]="'30rem'" [showScrollbar]="true"
        (visibleChange)="historyPanelOpen.set($event)">
        <ng-template #body>
            <div class="flex flex-col gap-2 p-2 overflow-y-auto" style="max-height: 25rem;">
                <div class="my-3 items-center">
                    <app-search-bar placeholder="Search a conversation" (searchChange)="searchThreads($event)"
                        width="100%"></app-search-bar>
                </div>
                @if (threadsLoading()) {
                <div class="text-center text-sm text-gray-400 py-4">Loading...</div>
                } @else {
                @for (history of threadsGroupedByDate(); track $index) {
                @if (history.length !== 0) {
                <span class="text-xs">{{ $index === 0 ? 'Today' : $index === 1 ? 'Last 7 days' : 'Last 30 Days'
                    }}</span>
                @for (thread of history; track thread._id) {
                <div class="rounded-base hover:bg-gray-200 p-2 cursor-pointer flex justify-between items-center"
                    [ngClass]="{'bg-orange-200': selectedThreadId() === thread._id}" (click)="selectThread(thread)">
                    <div class="flex flex-col gap-1 min-w-0 flex-1">
                        <span>{{ (thread.title || 'Untitled chat') | truncate:30 }}</span>
                        <span class="text-xs text-gray-500">{{ thread.createdAt | date }}</span>
                    </div>
                    <div class="relative shrink-0" (click)="$event.stopPropagation()">
                        <app-button variant="ghost" severity="contrast" icon="ellipsis-vertical" iconSource="lucide"
                            iconSize="sm" (clicked)="openThreadMenu($event, thread)"
                            [attr.aria-label]="'Thread options'" />
                    </div>
                </div>
                }
                }
                }
                @if (!hasAnyThreads()) {
                <div class="text-center text-sm">No Conversations</div>
                }
                }
            </div>

            <div class="p-2 items-center justify-center flex">
                <app-button label="New Chat" variant="filled" icon="plus" iconSource="lucide" [loading]="false"
                    severity="primary" (clicked)="startNewChat(); historyPanel.hide()" iconPosition="left" />
            </div>
        </ng-template>
    </app-popover>

    <!-- New chat (no thread selected) -->
    @if (!selectedThreadId()) {
    <div class="flex flex-col flex-1 overflow-hidden">
        <div class="flex items-center justify-end gap-2 p-2 flex-shrink-0">
            <app-credits-overview [variant]="'chip'" [needActionButtons]="false" [showViewUsage]="false"
                [showGetCreditsInChip]="true" />
            <app-button variant="filled" severity="primary" icon="history" iconSource="lucide" iconSize="default"
                (clicked)="toggleHistoryPanel($event)" [class]="'p-2 rounded-full'"
                [attr.aria-label]="'Open conversation history'" />
        </div>
        <div class="flex flex-col flex-1 items-center px-4 pt-[18vh]">
            <div class="w-full">
                <app-thread-input [showEmptyState]="true" [creationLoading]="isSending()"
                    [provider]="selectedProvider()" [documentId]="contractId()" [documentTypeId]="documentTypeId()"
                    [projectId]="projectId()" [compareId]="comparisonId()" [compareDocuments]="compareDocuments()"
                    [kpiDocuments]="kpiDocuments()" [formQuestions]="formQuestions()"
                    [selectedFormQuestionId]="selectedFormQuestionId()" [embeddingsStatus]="embeddingsStatus()"
                    (sendMessageEvent)="sendFirstMessage($event)">
                </app-thread-input>
            </div>
        </div>
    </div>
    }

    <!-- Active thread (thread selected) -->
    @if (selectedThreadId() && selectedThreadMetadataId()) {
    <app-active-thread class="block flex-1 min-h-0" [embeddedThreadId]="selectedThreadId()"
        [embeddedThreadMetadataId]="selectedThreadMetadataId()" [documentId]="contractId()"
        [documentTypeId]="documentTypeId()" [projectId]="projectId()" [compareDocuments]="compareDocuments()"
        [kpiDocuments]="kpiDocuments()" [formQuestions]="formQuestions()"
        [selectedFormQuestionId]="selectedFormQuestionId()" [showHistoryButton]="true"
        [embeddingsStatus]="embeddingsStatus()" (providerChange)="selectedProvider.set($event)" [isSidePannel]="true"
        [embeddedInitialMode]="currentMode()"
        (toggleHistoryRequest)="toggleHistoryPanel($event)" (threadDeleted)="onThreadDeleted()">
    </app-active-thread>
    }

</div>